import { SecondaryNavKey } from '../../../components/secondary-nav/models/secondary-nav-key';
import { setSecondaryNavOptions } from '../../../components/secondary-nav/repositories/secondary-nav.actions';
import { ALK_ROLES } from '../../../models/alk-roles';
import { PARTNER_ROLES } from '../../../models/partner-roles';
import { partnerSettingsSnapshot } from '../../../repositories/app-settings/app-settings.repository';
import { boolDefinedAndTrue } from '../../../utils/bool-defined-and-true';
import { composeRoles } from '../../../utils/compose-roles';
import { isFeatureEnabled } from '../../../repositories/feature-flags/feature-flags.repository';
import { dispatch } from '@ngneat/effects';
import { translate } from '@jsverse/transloco';
import { getCurrentAuthenticatedUser } from '@tmx/auth';

export function initSecondaryNavDiagnostics() {
  const hasAlkRole = composeRoles(ALK_ROLES)(
    getCurrentAuthenticatedUser().roles
  );
  const isPartnerWithDiagnosticsEnabled =
    composeRoles(PARTNER_ROLES)(getCurrentAuthenticatedUser().roles) &&
    partnerSettingsSnapshot().enableAmsDiagnostics;

  dispatch(
    setSecondaryNavOptions({
      key: SecondaryNavKey.Diagnostics,
      options: [
        {
          url: 'diagnostics/vehicle-search',
          displayName: translate('diagnostics.diagnostics.vehicleSearch'),
          disabled: !hasAlkRole && !isPartnerWithDiagnosticsEnabled,
        },
        {
          url: 'diagnostics/request-copilot-action',
          displayName: translate(
            'diagnostics.diagnostics.requestCopilotAction'
          ),
          disabled: !hasAlkRole && !isPartnerWithDiagnosticsEnabled,
        },
        {
          url: 'diagnostics/copilot-config-override',
          displayName: translate(
            'diagnostics.diagnostics.copilotConfigOverride'
          ),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/copilot-config-override-historical',
          displayName: translate(
            'diagnostics.diagnostics.copilotConfigOverrideHistorical'
          ),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/copilot-request-viewer',
          displayName: translate(
            'diagnostics.diagnostics.copilotRequestViewer'
          ),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/daily-metrics',
          displayName: translate('diagnostics.diagnostics.dailyMetrics'),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/daily-metrics-by-asset',
          displayName: translate('diagnostics.diagnostics.dailyMetricsByAsset'),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/mobile-instructions',
          displayName: translate('diagnostics.diagnostics.mobileInstructions'),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/mobile-instructions-historical',
          displayName: translate(
            'diagnostics.diagnostics.mobileInstructionsHistorical'
          ),
          disabled: !hasAlkRole,
        },
        {
          url: 'diagnostics/audit',
          displayName: translate('diagnostics.diagnostics.audit'),
          disabled: !hasAlkRole && !isPartnerWithDiagnosticsEnabled,
        },
        {
          url: 'diagnostics/time-to-activation',
          displayName: translate('diagnostics.diagnostics.timeToActivation'),
          disabled: !hasAlkRole || !isFeatureEnabled('time-to-activation'),
        },
        {
          url: 'diagnostics/copilot-churn',
          displayName: translate('diagnostics.diagnostics.copilotChurn'),
          disabled: !hasAlkRole || !isFeatureEnabled('copilot-churn'),
        },
        {
          url: 'diagnostics/trimby',
          displayName: translate('diagnostics.trimby.trimby'),
          disabled: !hasAlkRole || !isFeatureEnabled('trimby'),
        },
      ].filter((option) => !boolDefinedAndTrue(option.disabled)),
    })
  );
}
